import { render } from "./RactTool.vue?vue&type=template&id=13bb33f2&scoped=true"
import script from "./RactTool.js?vue&type=script&lang=js"
export * from "./RactTool.js?vue&type=script&lang=js"

import "./RactTool.vue?vue&type=style&index=0&id=13bb33f2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13bb33f2"]])

export default __exports__